import React from 'react';
import { deviceState, DEVICE_STATE_TONE } from '../utils/deviceState';

// Status pill with a leading dot, per the 2026-09 redesign.
//
// Two ways to use it:
//   <StatePill state="Deployed" />            explicit state
//   <StatePill device={d} allocations={s} />  derived via deviceState()
//
// For the derived form, pass {allocations, assignments} rather than a bare
// allocations array — deviceState() needs both to resolve "Assigned".
//
// Tones map to the existing .pill-{tone} classes in owl-bench-components.css,
// which are already built on the --{tone}-{fill,text,border} tokens.
function StatePill({ state, device, allocations = [], tone, className = '', style }) {
  const resolved = state || (device ? deviceState(device, allocations) : null);
  if (!resolved) return null;
  const t = tone || DEVICE_STATE_TONE[resolved] || 'neutral';
  return (
    <span className={`pill pill-${t} pill-dot ${className}`.trim()} style={style}>
      {resolved}
    </span>
  );
}

export default StatePill;
